var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { reduxBind } from 'badphraim/ui/LitReduxMixinBase';
import { css, html, LitElement } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { BoostPortalStore } from '../redux/BoostPortalStore';
import { litReduxBoostPortalMixin } from '../redux/LitReduxBoostPortalMixin';
import { BoostPortalTranslateMixin } from '../translation/TranslateBoostPortalMixin';
let BoostPortalMemberPrivatelySponsoredProgress = class BoostPortalMemberPrivatelySponsoredProgress extends BoostPortalTranslateMixin(litReduxBoostPortalMixin(LitElement)) {
    static get is() {
        return 'boost-portal-member-privately-sponsored-progress';
    }
    static get styles() {
        return css `
            .progress {
                display: flex;
                align-items: center;
                margin: 20px 0;
            }

            .progress div:last-child {
                flex: 1;
            }

            .progress div:first-child {
                margin-right: 10px;
            }

            .progress-heading {
                font-size: 140%;
                font-weight: 300;
            }

            .progress-info {
                font-size: 120%;
                font-weight: 300;
                text-align: right;
            }
        `;
    }
    /** @override */ render() {
        return html `
            <div>
                ${this.sponsorCode
            ? html `
                          <div class="progress">
                              <div class="progress-heading">${this.boostTranslate('code')}</div>
                              <div class="progress-info">${this.sponsorCode}</div>
                          </div>
                      `
            : html ``}
            </div>
        `;
    }
    _getSelectedDepartment() {
        const selectedDepartment = this.departments &&
            this.departments.find((department) => department.id === this.selectedDepartmentId);
        if (!selectedDepartment) {
            return html ``;
        }
        return html ` ${selectedDepartment.navn} `;
    }
    _getSelectedMembership() {
        const selectedMembership = this.memberships &&
            this.memberships.find((membership) => membership.id === this.selectedMembershipId);
        if (!selectedMembership) {
            return html ``;
        }
        return html ` ${selectedMembership.title} `;
    }
};
BoostPortalMemberPrivatelySponsoredProgress._deps = [];
__decorate([
    reduxBind(BoostPortalStore.path('departments')),
    state(),
    __metadata("design:type", Array)
], BoostPortalMemberPrivatelySponsoredProgress.prototype, "departments", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('memberships')),
    state(),
    __metadata("design:type", Array)
], BoostPortalMemberPrivatelySponsoredProgress.prototype, "memberships", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('selectedDepartmentId')),
    state(),
    __metadata("design:type", Number)
], BoostPortalMemberPrivatelySponsoredProgress.prototype, "selectedDepartmentId", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('selectedMembershipId')),
    state(),
    __metadata("design:type", Number)
], BoostPortalMemberPrivatelySponsoredProgress.prototype, "selectedMembershipId", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('sponsorCode')),
    state(),
    __metadata("design:type", String)
], BoostPortalMemberPrivatelySponsoredProgress.prototype, "sponsorCode", void 0);
BoostPortalMemberPrivatelySponsoredProgress = __decorate([
    customElement(BoostPortalMemberPrivatelySponsoredProgress.is)
], BoostPortalMemberPrivatelySponsoredProgress);
export { BoostPortalMemberPrivatelySponsoredProgress };
